<div class="settings-container">
  <div class="settings-header">
    <div class="settings-title">
      <button class="mobile-menu-toggle" (click)="toggleMobileMenu()" aria-label="Toggle menu">
        <fa-icon [icon]="mobileMenuOpen ? faTimes : faBars"></fa-icon>
      </button>
      <h2>{{ 'SETTINGS.TITLE' | translate }}</h2>
    </div>
    <div class="settings-actions">
      <orbit-button [label]="'SETTINGS.CLOSE' | translate" (click)="closeSettings()"></orbit-button>
    </div>
  </div>
  <div class="settings-content-wrapper">
    @if (mobileMenuOpen) {
      <div
        class="backdrop-overlay"
        (click)="closeMobileMenu()"
        tabindex="0"
        role="button"
        aria-label="Close menu"></div>
    }
    <div class="settings-sidebar" [class.mobile-menu-open]="mobileMenuOpen">
      <nav class="settings-nav">
        <ul>
          @for (item of navItems; track item.route) {
            <li>
              <a [routerLink]="[item.route]" routerLinkActive="active" (click)="closeMobileMenu()">
                {{ item.label | translate }}
              </a>
            </li>
          }
        </ul>
      </nav>
    </div>
    <div class="settings-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
